<template>
  <div>
    <!-- Hero Section -->
    <section class="py-20 bg-gradient-dark">
      <div class="container mx-auto px-6 text-center">
        <div class="flex items-center justify-center mb-6">
          <router-link to="/services" class="text-gold-400 hover:text-gold-300 transition-colors duration-300 mr-4">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
          </router-link>
          <h1 class="text-4xl md:text-6xl font-display font-bold text-gold-400">
            IMPLANT RESTORATIONS
          </h1>
        </div>
        <p class="text-xl text-gold-300 max-w-3xl mx-auto">
          Advanced implant-supported solutions for optimal function, aesthetics, and longevity.
        </p>
      </div>
    </section>

    <!-- Products -->
    <section class="py-20">
      <div class="container mx-auto px-6">
        <div class="max-w-4xl mx-auto">
          <div class="bg-black-800 rounded-2xl p-8 border border-gold-800">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
              <!-- Screw-Retained Crowns -->
              <div class="text-center p-6">
                <div class="w-20 h-20 bg-gradient-gold rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg class="w-10 h-10 text-black-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
                  </svg>
                </div>
                <h3 class="text-2xl font-display font-bold text-gold-400 mb-4">Screw-Retained Crowns</h3>
                <p class="text-gray-300">Secure, retrievable implant crowns with optimal hygiene access.</p>
              </div>
              
              <!-- Custom Abutments -->
              <div class="text-center p-6">
                <div class="w-20 h-20 bg-gradient-gold rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg class="w-10 h-10 text-black-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" />
                  </svg>
                </div>
                <h3 class="text-2xl font-display font-bold text-gold-400 mb-4">Custom Abutments</h3>
                <p class="text-gray-300">Patient-specific abutments for ideal emergence profiles and aesthetics.</p>
              </div>
              
              <!-- All-on-X Full Arch Restorations -->
              <div class="text-center p-6">
                <div class="w-20 h-20 bg-gradient-gold rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg class="w-10 h-10 text-black-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                  </svg>
                </div>
                <h3 class="text-2xl font-display font-bold text-gold-400 mb-4">All-on-X Full Arch Restorations</h3>
                <p class="text-gray-300">Complete arch solutions with immediate function and optimal support.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Back to Services -->
    <section class="py-20">
      <div class="container mx-auto px-6 text-center">
        <router-link to="/services" class="btn-secondary inline-flex items-center">
          <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Back to All Services
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ImplantServices'
}
</script>